import { ToolbarProps } from './types'
import AsideMenu from './AsideMenu'

const Toolbar = ({ children }: ToolbarProps) => {
	return (
		<aside className='main-layout-toolbar w-full h-full bg-gray-200 md:bg-black-light'>
			<div className='w-full h-full flex flex-row md:flex-col items-center  p-1 md:p-0'>
				<AsideMenu />
				<section className='ml-4 md:ml-0 md:mt-4'>{children}</section>
			</div>
		</aside>
	)
}

export default Toolbar
